import { render, staticRenderFns } from "./salaryComparison.vue?vue&type=template&id=928fde86&"
import script from "./salaryComparison.vue?vue&type=script&lang=js&"
export * from "./salaryComparison.vue?vue&type=script&lang=js&"
import style0 from "./salaryComparison.vue?vue&type=style&index=0&id=928fde86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports